import {Typography} from '@mui/material';
import React from 'react';

export default function SomethingWentWrongFallbackUI() {
  return <Typography>Something went wrong!</Typography>;
}
